import { KYBStatusEnum } from "@finway-group/shared/lib/models"
import { Beneficiary } from "~Shared/store/reducers/corporateReducer"

export const getBeneficiariesWithOngoingKybStatusInitiated = (beneficiaries: Array<Beneficiary>) =>
    beneficiaries?.filter((beneficiary) => beneficiary.ongoingKybStatus === KYBStatusEnum.INITIATED)
